"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mediaPlayerSettings;
var _constants = require("@studio/constants");
var _types = require("../../actions/types");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var PLAY = 'play';
var initialState = {};
function getSourceMediaState(state, sourceId) {
  return state[sourceId] ? _objectSpread({}, state[sourceId]) : _objectSpread({}, _constants.MediaPlayer);
}
function mediaPlayerSettings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.MEDIA_PLAYER_TOGGLE_PLAY) {
    var _action$payload = action.payload,
      playState = _action$payload.playState,
      sourceId = _action$payload.sourceId;
    var isPlaying = playState === PLAY;
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, sourceId, _objectSpread(_objectSpread({}, getSourceMediaState(state, sourceId)), {}, {
      isPlaying: isPlaying
    })));
  }
  if (action.type === _types.MEDIA_PLAYER_VOLUME_CHANGE) {
    var _action$payload2 = action.payload,
      volume = _action$payload2.volume,
      _sourceId = _action$payload2.sourceId;
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, _sourceId, _objectSpread(_objectSpread({}, getSourceMediaState(state, _sourceId)), {}, {
      volume: volume
    })));
  }
  if (action.type === _types.SET_MEDIA_PLAYER_SETTINGS) {
    return action.payload;
  }
  if (action.type === _types.UPDATE_MEDIA_PLAYER_SETTINGS) {
    var _action$payload3 = action.payload,
      _sourceId2 = _action$payload3.sourceId,
      settings = _action$payload3.settings;
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, _sourceId2, _objectSpread(_objectSpread({}, getSourceMediaState(state, _sourceId2)), settings)));
  }
  if (action.type === _types.MEDIA_PLAYER_LOOP_MEDIA) {
    var _action$payload4 = action.payload,
      loop = _action$payload4.loop,
      _sourceId3 = _action$payload4.sourceId;
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, _sourceId3, _objectSpread(_objectSpread({}, getSourceMediaState(state, _sourceId3)), {}, {
      loop: loop
    })));
  }
  if (action.type === _types.MEDIA_PLAYER_MUTE_MEDIA) {
    var _action$payload5 = action.payload,
      muted = _action$payload5.muted,
      _sourceId4 = _action$payload5.sourceId;
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, _sourceId4, _objectSpread(_objectSpread({}, getSourceMediaState(state, _sourceId4)), {}, {
      muted: muted
    })));
  }
  if (action.type === _types.MEDIA_PLAYER_SET_DURATION) {
    var _action$payload6 = action.payload,
      duration = _action$payload6.duration,
      _sourceId5 = _action$payload6.sourceId;
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, _sourceId5, _objectSpread(_objectSpread({}, getSourceMediaState(state, _sourceId5)), {}, {
      duration: duration
    })));
  }
  return state;
}